module.exports = __webpack_public_path__ + "chairs-9364f309.jpg";